<template>
  <Wrapper>
    <Dashboard>
      <SignFlow :document-uid="documentUid" :redirect-url="redirectUrl" />
    </Dashboard>
  </Wrapper>
</template>

<script setup lang="ts">
import { parseDeepSignUrl } from '@/util'
import { useDashboardData } from '@/composables/use-dashboard-data.ts'
import SignFlow from '@/components/sign/SignFlow.vue'
import Dashboard from '@/components/wrappers/Dashboard.vue'
import Wrapper from '@/components/wrappers/Wrapper.vue'

definePage({
  path: '/sign/:documentUid',
  name: 'sign',
  meta: {
    titleKey: 'tab.sign',
    requiresAuth: true,
  },
})

const route = useRoute()
const { fetchDashboardData } = useDashboardData()

onMounted(() => {
  fetchDashboardData(['naturalPersonMe', 'emailAddress'])
})

const documentUid = route.params.documentUid as string

// DeepSign is expected to pass its own return URL, mirroring the native
// app's `postSignatureRedirectUrl`; only ever navigate to a known DeepSign host.
const redirectUrl = computed(() =>
  parseDeepSignUrl(route.query.redirectUrl)?.toString(),
)
</script>
